import {ActionIcon, createStyles, Tooltip} from '@mantine/core';
import React from 'react';

import navigateToURL from 'lib/navigateToURL';
import {ChatSettingsTab} from 'llm/chat-library/sidepanel/AISidepanelV2GlobalClientState';
import {chatSettingsModalUrl} from 'llm/routes/UrlUtils';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {redesignHeaderIconChipStyles} from './RedesignHeaderIconChip';

const useStyles = createStyles(() => ({
  button: redesignHeaderIconChipStyles,
}));

/**
 * The redesigned sidebar's action buttons (chat settings, and eventually search), shared by both the
 * wide-view sidebar toolbar and the semi-expanded header so the two don't drift. Add new actions here,
 * in this single place, so they stay in sync.
 */
export default function RedesignSidebarActions(): JSX.Element {
  const {classes} = useStyles();
  return (
    <>
      {/* TODO(BNCH-168126): add the search action here once a search UI is designed. */}
      <Tooltip label="Chat settings">
        <ActionIcon
          aria-label="Chat settings"
          variant="subtle"
          size="md"
          className={classes.button}
          onClick={() => navigateToURL(chatSettingsModalUrl(ChatSettingsTab.GENERAL))}
        >
          <BenchlingIcon icon="gear-outline" />
        </ActionIcon>
      </Tooltip>
    </>
  );
}
